<template>
  <span>{{ text }}</span>
</template>

<script>
export default {
  props: {
    value: {
      type: [String, Object, Number],
      default: "",
    },
  },
  computed: {
    text() {
      return this.value?.title ?? this.value;
    },
  },
  methods: {
    isObject(value) {
      return value instanceof Object;
    },
  },
};
</script>
